import HeaderComponent from "../HeaderComponent";
import SectionComponent from "../SectionComponent";
import TextComponent from "../TextComponent";
import NavigationContainerComponent from "../NavigationContainerComponent";
import NavItemComponent from "../NavItemComponent";
import ButtonComponent from "../ButtonComponent";
import InnerSectionComponent from "../InnerSectionComponent";
import ImageComponent from "../ImageComponent";

export var defaultComponents: { [key: string]: any } = {
  header: HeaderComponent,
  section: SectionComponent,
  text: TextComponent,
  "navigation-container": NavigationContainerComponent,
  "nav-item": NavItemComponent,
  Button: ButtonComponent,
  inner_section: InnerSectionComponent,
  image: ImageComponent,
};
